// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth"
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCVtG0W4NK6tzhNuwErG2wGXseUvOV_D5o",
  authDomain: "aerophilia-3f429.firebaseapp.com",
  projectId: "aerophilia-3f429",
  storageBucket: "aerophilia-3f429.appspot.com",
  messagingSenderId: "64954801094",
  appId: "1:64954801094:web:4d51fde56ba06ffa52f0c7",
  measurementId: "G-PFQ34NT5Y0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);


